import { API_URL } from './config';
import { auth } from '../firebase/config';
import { apiFetch, traceAction } from './apiFetch';

export interface UpdateOrderResult {
  ok: boolean;
  changed: boolean;
  written?: string[];
  suppressed?: {
    field: string;
    from: string;
    to: string;
  } | null;
}

export const updateOrderDoc = async (orderId: string, update: Record<string, any>, allowRegression?: boolean): Promise<UpdateOrderResult> => {
  const idToken = await auth.currentUser?.getIdToken();
  const correlationId = traceAction('order_status_update_requested', { orderId, update, allowRegression });

  const res = await apiFetch(
    `${API_URL}/updateOrderStatus`,
    {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
      body: JSON.stringify({ orderId, update, allowRegression }),
    },
    correlationId
  );

  const data = await res.json().catch(() => ({}));

  if (!res.ok || data?.ok === false) {
    const error: any = new Error(data?.error || `HTTP_${res.status}`);
    error.code = data?.error;
    error.details = data?.rejected || data?.details;
    throw error;
  }

  return data as UpdateOrderResult;
};
